import type { SupervisorButton } from '../types/supervisorButtons';

// Export proposal is a text-only action everywhere it appears.
const TEXT_ONLY_BUTTON_KEYS = new Set(['export']);

const ICON_BY_BUTTON_KEY: Record<string, string> = {
  share_design: 'fa-solid fa-share-nodes',
  edit_design: 'fa-solid fa-pen-nib',
  deploy_stage: 'fa-solid fa-cloud-arrow-up',
  open_live_preview: 'fa-solid fa-desktop',
  download_code: 'fa-solid fa-download',
  create_org: 'fa-solid fa-building',
  add_member: 'fa-solid fa-user-plus',
  see_tasks: 'fa-solid fa-list-check',
  install_vscode_extension: 'fa-solid fa-arrow-up-right-from-square',
  keep_talking: 'fa-regular fa-message',
  build: 'fa-solid fa-wrench',
  start_build: 'fa-solid fa-wrench',
  run_agents: 'fa-solid fa-play',
  run_requirements: 'fa-solid fa-play',
  run_user_flows: 'fa-solid fa-play',
  run_design: 'fa-solid fa-play',
  run_architecture: 'fa-solid fa-play',
  run_tasks: 'fa-solid fa-play',
  run_start: 'fa-solid fa-play',
};

const ACTION_CLASS_BY_BUTTON_KEY: Record<string, string> = {
  export: 'export-proposal',
  share_design: 'share-design',
  edit_design: 'edit-design',
  deploy_stage: 'deploy-stage',
  open_live_preview: 'open-live-preview',
  download_code: 'download-code',
  create_org: 'create-org',
  add_member: 'add-member',
  see_tasks: 'see-tasks',
  install_vscode_extension: 'install-vscode-extension',
};

/** Empty for text-only actions. */
export const iconClassForSupervisorButton = (button: SupervisorButton): string => (
  TEXT_ONLY_BUTTON_KEYS.has(button.key) ? '' : ICON_BY_BUTTON_KEY[button.key] || 'fa-solid fa-arrow-right'
);

export const actionClassForSupervisorButton = (button: SupervisorButton): string => (
  ACTION_CLASS_BY_BUTTON_KEY[button.key] || 'generic-action'
);

export const loadingLabelForSupervisorButton = (button: SupervisorButton): string => {
  if (button.action === 'download_code') return 'Downloading...';
  if (button.action === 'navigate') return 'Opening...';
  if (button.action === 'trigger_export_proposal') return 'Opening...';
  if (button.action === 'open_share_modal') return 'Opening...';
  if (button.action === 'open_design_editor') return 'Opening...';
  if (button.action === 'trigger_stage_deploy') return 'Deploying...';

  return 'Working...';
};
